module.exports = __webpack_public_path__ + "static/media/pneumonia-vaccine-news.ac771298.jpg";